import { render, staticRenderFns } from "./FjResponse.vue?vue&type=template&id=39165a50&scoped=true&"
import script from "./FjResponse.vue?vue&type=script&lang=js&"
export * from "./FjResponse.vue?vue&type=script&lang=js&"
import style0 from "./FjResponse.vue?vue&type=style&index=0&id=39165a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39165a50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
